import React from 'react'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'
import { Info } from '@phosphor-icons/react'

const Tooltip = ({ tooltips }) => {
  return (
    <React.Fragment>
      <span data-tip data-for="announcements-analytics-select-mail-list" className="tooltip-icon">
        <Info size={20} />
      </span>
      <ReactTooltip
        id="announcements-analytics-select-mail-list"
        multiline
        place="right"
        effect="solid"
      >
        {tooltips.map((tip, index) => (
          <p key={index}>{tip}</p>
        ))}
      </ReactTooltip>
    </React.Fragment>
  )
}

Tooltip.propTypes = {
  tooltips: PropTypes.array.isRequired,
}

export default Tooltip
